import { render, staticRenderFns } from "./StatusListPage.vue?vue&type=template&id=e7572e12&scoped=true&"
import script from "./StatusListPage.vue?vue&type=script&lang=ts&"
export * from "./StatusListPage.vue?vue&type=script&lang=ts&"
import style0 from "./StatusListPage.vue?vue&type=style&index=0&id=e7572e12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7572e12",
  null
  
)

export default component.exports